//const Imageurldata = "http://localhost:4000/";
// const Imageurldata = "https://api.laxmihos.com/api/";
// const urldata = "https://api.laxmihos.com/api/api/";
const Imageurldata = process.env.REACT_APP_AZURE_OBJECT_URL + "public/";
export default Imageurldata;
